var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLastSeen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 15C6.61552 15 5.26215 14.5895 4.111 13.8203C2.95986 13.0511 2.06265 11.9579 1.53284 10.6788C1.00302 9.3997 0.864399 7.99224 1.1345 6.63437C1.40459 5.2765 2.07128 4.02922 3.05025 3.05026C4.02921 2.07129 5.27649 1.4046 6.63436 1.13451C7.99223 0.86441 9.39969 1.00303 10.6788 1.53285C11.9579 2.06266 13.0511 2.95987 13.8203 4.11101C14.5895 5.26216 15 6.61553 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85651 15 7.99999 15ZM7.99999 2C6.81331 2 5.65327 2.3519 4.66657 3.01119C3.67988 3.67047 2.91084 4.60755 2.45672 5.7039C2.00259 6.80026 1.88377 8.00666 2.11528 9.17054C2.34679 10.3344 2.91824 11.4035 3.75735 12.2426C4.59647 13.0818 5.66557 13.6532 6.82945 13.8847C7.99334 14.1162 9.19974 13.9974 10.2961 13.5433C11.3924 13.0892 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.18669 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.59129 2 7.99999 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.295 11L7.49999 8.205V3.5H8.49999V7.79L11 10.295L10.295 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLastSeen);
export default __webpack_public_path__ + "static/media/ic-last-seen.11304aaf1a4341f5e680001ec224f4b7.svg";
export { ForwardRef as ReactComponent };